
const signin = async (user,type) =>{
    try{
       
        var suffix = "/api/manager/login"
        if(type == "1"){
            suffix = "/api/customer/login";
        }else if (type === "2"){
            suffix = "/api/clerk/login";
        }else if (type === "3"){
            suffix = "/api/manager/login";
        }else if (type === "4"){
            suffix = "/api/admin/login";
        }
        let response = await fetch(process.env["REACT_APP_API_HOST"]+ suffix,{
            method:'POST',
            headers:{
                'Accept':'application/json',
                'Content-type':'application/json',
            },
           // credentials:'include',
            body:JSON.stringify(user)
        })
        return await response.json()
    }
    catch (err) {
       console.log(err)
    }
}
const signout = async ()=>{
    try{
        let response = await fetch(process.env["REACT_APP_API_HOST "]+'/api/user/logout',{
            method:'GET'
        })
        return await  response.json()
    } catch (err) {
       console.log(err)
    }
}

export {signin,signout}